export const navigateTo = (
  page: string,
  navigate: (url: string) => void,
  patientId: string | number,
  caseId: string | number,
  isPatientOverview?: boolean, 
) => {
  switch (page) {
    case "RECORDS":
      navigate(`/patients/choosetype/patient/${patientId}/case/${caseId}`)
      break
    case "PRESCRIPTION":
      navigate(
        `/records/patient/${patientId}/case/${caseId}/rxForm/prescription`,
      )
      break
    case "SUMMARY":
      navigate(`/records/patient/${patientId}/case/${caseId}/rxForm/summary`)
      break
    case "OverViewSUMMARY":
      navigate(`/records/patient/${patientId}/case/${caseId}/rxForm/summary`)
      break
    case "RETAINER":
      navigate(`/overview/patient/${patientId}/case/${caseId}/form/retainer`)
      break
    case "TREAT":
      navigate(`/clinical/patient/${patientId}/case/${caseId}/treat`)
      break
    case "REFINEMENT":
      window.open(
        `/clinical/patient/${patientId}/case/${caseId}/treat?${isPatientOverview ? "from=overview&" : ""
        }doRefinement=true`,
        "_blank",
      )
      break
    default:
      console.log("action", caseId)
  }
}

/**
 * Converts a comma-separated string of numbers into a range string.
 * Consecutive numbers are grouped as a range (e.g., "5,6,7" → "5-7").
 * Non-consecutive numbers are listed individually (e.g., "1,5,10" → "1,5,10").
 * Mixed cases are handled (e.g., "1,5,6,7" → "1,5-7").
 * @param rangeValues - A string containing comma-separated numbers (e.g., "8,6,7").
 * @returns A string representing the range(s) (e.g., "6-8" or "1,5-7").
 */
export const getAlignerRange = (rangeValues: string): string => {
  // Handle non-string input
  if (typeof rangeValues !== 'string') return ''
  // Remove whitespace and filter out empty values
  const values = rangeValues
    .split(',')
    .map(v => v.trim())
    .filter(v => v.length > 0)
    .map(Number)
    .filter(v => !isNaN(v))
  // Remove duplicates
  const uniqueValues = Array.from(new Set(values))
  if (uniqueValues.length === 0) return ''
  uniqueValues.sort((a, b) => a - b)

  const result: string[] = []
  let start = uniqueValues[0]
  let end = uniqueValues[0]

  for (let i = 1; i <= uniqueValues.length; i++) {
    if (uniqueValues[i] === end + 1) {
      end = uniqueValues[i]
    } else {
      if (start === end) {
        result.push(`${start}`)
      } else if (end === start + 1) {
        result.push(`${start},${end}`)
      } else {
        result.push(`${start}-${end}`)
      }
      start = uniqueValues[i]
      end = uniqueValues[i]
    }
  }
  return result.join(',')
}
